import { observer } from 'mobx-react';
import React, { useEffect, useRef, useState } from 'react';
import Loader from './LoaderTemplate';
import _ from 'lodash';
import { localStorageHandler } from 'core/services';

const SubmitTicketTemplate = observer(() => {
	const [isLoading, setIsLoading] = useState(true);
	const formContainerRef = useRef(null);
	const formId = '0a30deba-4081-470c-ae46-71a9aa65ae16';

	useEffect(() => {
		// Set up global event listener
		const handleFormReady = async event => {
			// Only proceed if the event belongs to this form instance
			if (event.detail.formId !== formId) return;

			setIsLoading(false);

			if (window.HubSpotFormsV4) {
				const formInstance = window.HubSpotFormsV4.getFormFromEvent(event);

				formInstance.setFieldValue('0-5/url', window.location.href);

				let organizationName = localStorageHandler.get('lastOrganization');
				if (organizationName) {
					formInstance.setFieldValue('0-5/organization', organizationName.applicationTitle);
				}

				// TODO later
				// formInstance.setFieldValue(
				// 	'0-5/order_number',
				// 	'test order number'
				// );
			}
		};

		// Add the listener to the global window object
		window.addEventListener('hs-form-event:on-ready', handleFormReady);

		// Cleanup function
		return () => {
			window.removeEventListener('hs-form-event:on-ready', handleFormReady);
		};
	}, []);

	return (
		<React.Fragment>
			{isLoading && <Loader />}

			<section ref={formContainerRef}>
				<div
					className="hs-form-frame"
					data-region="na1"
					data-form-id={formId}
					data-portal-id="23807806"
				></div>
			</section>
		</React.Fragment>
	);
});

export default SubmitTicketTemplate;
